import { ButtonLink, DataSmallTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledButtonLink = styled(ButtonLink)`
  ${DataSmallTypography};
`
